import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flow } from 'signup-constants/Flow';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { HubsTrackingAttr } from 'signup-constants/HubsTrackingAttr';
import { addUrlParams } from 'LearningCenterUI/utils/RoutingUtils';
import { useCallback } from 'react';
import { getBrochureRoot, useAchievementTrackId, useAchievementUser } from '../achievementQueries';
import ViralTrackingPixel from 'viral-links-lib/viral-tracking/ViralTrackingPixel';
import { getTrackedSignupUrl } from 'viral-links-lib/viral-tracking/viral-urls';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const addCtaParam = (href, cta) => addUrlParams(href, {
  'hubs_content-cta': cta
});
const BUTTON_TYPES = {
  SIGNUP: 'signup',
  ACADEMY_HOME: 'academyHome'
};
const FooterCTA = ({
  trackEvent,
  publicId,
  language
}) => {
  const {
    isNotMobile
  } = useMediaQuery();
  const trackId = useAchievementTrackId(publicId);
  const user = useAchievementUser(publicId);
  const brochureRoot = getBrochureRoot(language);
  const userId = user && user.userId;
  const isMarketingThemeEnabled = getMarketingThemePreference();
  const viralLinkType = 'academy-achievements';
  const signupUrl = getTrackedSignupUrl({
    flow: Flow.Academy,
    viralLinkType,
    additionalParams: {
      [SignupQueryKeys.OptSidebar]: 'true',
      [SignupQueryKeys.Intent]: 'learningCenter',
      [HubsTrackingAttr.Campaign]: 'hubspot-academy-achievements-virality',
      [HubsTrackingAttr.Medium]: 'virality',
      track: trackId ? trackId.toString() : '',
      viralSourceUserId: userId ? userId.toString() : '',
      'hubs_signup-url': window.location.href,
      'hubs_signup-cta': 'achievement-cta-sticky'
    }
  });
  const getButtonClickHandler = useCallback(buttonType => ({
    currentTarget
  }) => trackEvent({
    action: 'click-footer-cta-button',
    buttonType,
    href: currentTarget.href,
    isExternalLink: true
  }), [trackEvent]);
  return /*#__PURE__*/_jsx("div", {
    style: {
      position: 'fixed',
      bottom: '0',
      width: '100%'
    },
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      backgroundColor: isMarketingThemeEnabled ? 'specialty-tertiary-on-fill-default' : 'fill-brand-default',
      "data-test-id": "virality-footer",
      gap: "300",
      justifyContent: "center",
      padding: "300",
      children: [isNotMobile && /*#__PURE__*/_jsx(Text, {
        color: "text-core-on-fill-default",
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.signupCta.wantToGrow"
        })
      }), userId ? /*#__PURE__*/_jsx(ViralTrackingPixel, {
        userId: userId,
        viralLinkType: viralLinkType
      }) : /*#__PURE__*/_jsx(ViralTrackingPixel, {
        viralLinkType: viralLinkType
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "virality-button",
        href: signupUrl,
        marginInline: "0",
        onClick: getButtonClickHandler(BUTTON_TYPES.SIGNUP),
        responsive: false,
        use: "primary-white",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.signupCta.signUp"
        })
      }), /*#__PURE__*/_jsx(Button, {
        href: addCtaParam(brochureRoot, 'achievement-cta-find-my-own'),
        marginInline: "0",
        onClick: getButtonClickHandler(BUTTON_TYPES.ACADEMY_HOME),
        responsive: false,
        use: "secondary-ghost",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.signupCta.findOwnCourses"
        })
      })]
    })
  });
};
export default FooterCTA;